/* eslint-disable no-plusplus */
import lod_ from "lodash";
import { t } from "i18next";
import { useEffect, useState } from "react";
import MDBox from "components/Basics/MDBox";
import { Icon, IconButton, TableCell, Tooltip } from "@mui/material";
import DictionaryMenu from "pages/settings/filters/DictionaryMenu";
import MDInput from "components/Basics/MDInput";
import { grey } from "@mui/material/colors";

const RowInput = ({ value: valueProps = "", onChange = () => {}, ...rest }) => {
	const [value, setValue] = useState(valueProps);

	useEffect(() => {
		setValue(valueProps);
	}, [valueProps]);

	return (
		<MDInput
			fullWidth
			value={value}
			onChange={e => setValue(e.target.value)}
			onBlur={e => {
				onChange(e.target.value);
			}}
			{...rest}
		/>
	);
};

const RowMapping = ({ dictionaries, path, value, onChangePath, onChangeValue, deleteRow }) => {
	const [anchorElInput, setAnchorElInput] = useState(null);
	const [anchorElOutput, setAnchorElOutput] = useState(null);

	// If not found in dictionaries, it's a custom value
	const [isCustomValue, setIsCustomValue] = useState(false);

	/**
	 * Get the path's label for a dictionary
	 * @param {*} dictionary
	 * @param {*} path
	 * @returns
	 */
	const getPath = (dictionary, path) => {
		if (!path) {
			return null;
		}

		const parts = path.split(".");

		const result = [];
		let current = "";

		for (let i = 0; i < parts.length; i++) {
			current += parts[i];
			result.push(current);
			current += ".items.";
		}

		let stringPath = "";

		for (let i = 0; i < result.length; i++) {
			stringPath += " " + lod_.get(dictionary, result[i] + ".label.fr") + " /" || "";
		}

		stringPath = stringPath.slice(0, -1);
		return stringPath;
	};

	const [temporaryPath, setTemporaryPath] = useState(path);

	const onChange = inputValue => {
		inputValue = inputValue.replaceAll(" ", "");
		inputValue = inputValue.replaceAll(/\.{2,}/g, ".");

		// if temporaryPath finish with a dot, remove it
		if (inputValue.endsWith(".")) {
			inputValue = inputValue.slice(0, -1);
		}

		setTemporaryPath(inputValue);

		onChangePath(path, inputValue, value);
	};

	useEffect(() => {
		if (typeof value !== "string") {
			setIsCustomValue(true);
			return;
		}
		const path = value.replaceAll(".", ".items.");
		if (lod_.has(dictionaries, path) || value === "") {
			setIsCustomValue(false);
		} else {
			setIsCustomValue(true);
		}
	}, [value]);

	return (
		<MDBox display="flex" flexDirection="row" alignItems="center" style={{ width: "100%" }}>
			<TableCell style={{ border: "none" }} width="50%">
				<MDBox
					display="flex"
					flexDirection="row"
					justifyContent="space-between"
					alignItems="stretch"
				>
					<RowInput
						value={temporaryPath}
						onChange={e => {
							onChange(e);
						}}
						sx={{
							"& .MuiOutlinedInput-root": {
								height: "100%"
							}
						}}
						InputProps={{
							sx: {
								borderRadius: "0.375rem 0 0 0.375rem"
							}
						}}
					/>
					<MDBox
						className="endButtonboxInputStyle"
						display="flex"
						justifyContent="center"
						alignItems="center"
						bgColor="light"
						onClick={e => setAnchorElOutput(e.target)}
					>
						<Icon fontSize="small">menu</Icon>
					</MDBox>
					<DictionaryMenu
						placement="right"
						dictionary={dictionaries}
						anchorEl={anchorElOutput}
						handleInsertText={e => {
							setAnchorElOutput(null);
							onChange(e);
						}}
						handleClose={() => setAnchorElOutput(null)}
					/>
				</MDBox>
			</TableCell>
			{/* Mid cell */}
			<TableCell style={{ border: "none" }}>
				<MDBox display="flex" flexDirection="row" justifyContent="center" alignItems="center">
					<Icon color="success" fontSize="medium">
						arrow_backward
					</Icon>
				</MDBox>
			</TableCell>
			{/* Input */}
			<TableCell style={{ border: "none" }} width="50%">
				<MDBox
					display="flex"
					flexDirection="row"
					justifyContent="space-between"
					alignItems="stretch"
				>
					{isCustomValue && (
						<RowInput
							value={value}
							onChange={e => {
								onChangeValue(path, e);
							}}
							sx={{
								"& .MuiOutlinedInput-root": {
									height: "100%"
								}
							}}
							InputProps={{
								sx: {
									borderRadius: "0.375rem 0 0 0.375rem"
								}
							}}
						/>
					)}
					{!isCustomValue && (
						<MDBox
							flex="1"
							className="boxInputStyle"
							borderRadius="md"
							style={{
								borderRadius: "0.375rem 0 0 0.375rem"
							}}
						>
							{getPath(dictionaries, value)}
						</MDBox>
					)}

					<Tooltip title="Valeur personnalisée" placement="top">
						<MDBox
							className="endButtonboxInputStyle"
							display="flex"
							justifyContent="center"
							alignItems="center"
							bgColor={isCustomValue ? "dark" : "light"}
							style={{
								borderRadius: "0"
							}}
							onClick={() => {
								setIsCustomValue(!isCustomValue);
								onChangeValue(path, "");
							}}
						>
							<Icon
								style={{
									color: isCustomValue ? grey[50] : "inherit"
								}}
								fontSize="small"
							>
								edit
							</Icon>
						</MDBox>
					</Tooltip>
					<MDBox
						className="endButtonboxInputStyle"
						display="flex"
						justifyContent="center"
						alignItems="center"
						bgColor="light"
						onClick={e => setAnchorElInput(e.target)}
					>
						<Icon fontSize="small">menu</Icon>
					</MDBox>
					<DictionaryMenu
						placement="right"
						dictionary={dictionaries}
						anchorEl={anchorElInput}
						handleInsertText={e => {
							setAnchorElInput(null);
							onChangeValue(path, e);
						}}
						handleClose={() => setAnchorElInput(null)}
					/>
				</MDBox>
			</TableCell>
			<IconButton onClick={() => deleteRow(path)}>
				<Icon>delete</Icon>
			</IconButton>
		</MDBox>
	);
};

export default RowMapping;
